export default __webpack_public_path__ + "static/media/dataWalk.71db4f2b.png";